import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import Decimal from 'decimal.js';
import { VivawalletCustomer } from '../vivawallet-customer';
import { VivawalletPaymentOrderPost } from '../vivawallet-payment-order-post';

@Component({
  selector: 'app-test-vivawallet',
  templateUrl: './test-vivawallet.component.html',
  styleUrls: ['./test-vivawallet.component.css']
})
export class TestVivawalletComponent implements OnInit {

  checkoutForm: FormGroup;
  checkoutUrl!: string;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService
  ) {
    this.checkoutForm = this.builder.group({
      amount: [null, Validators.required],
      email: [null, Validators.required],
      customerName: [null, Validators.required],
      messageToCustomer: [null, Validators.required]
    });
   }

  ngOnInit(): void {

  }

  postPaymentOrder(){
    let amountDecimal = new Decimal(this.checkoutForm.value.amount).times(100);

    let paymentOrder = new VivawalletPaymentOrderPost(
      amountDecimal.toNumber(),
      this.checkoutForm.value.messageToCustomer,
      new VivawalletCustomer(
        this.checkoutForm.value.email,
        this.checkoutForm.value.customerName,
        null,
        null,
        null
      )
    );
    this.httpService.postVivawalletPaymentOrder(paymentOrder).subscribe(res => {
      console.log(res);
      this.checkoutUrl = res;
    });
  }

}
